import { render } from "./RobotInformation.vue?vue&type=template&id=690d43e8"
import script from "./RobotInformation.vue?vue&type=script&lang=js"
export * from "./RobotInformation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\benny\\Documents\\Programmieren\\Vue\\cellCalculator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__